import { render, staticRenderFns } from "./PptCircleAttr.vue?vue&type=template&id=3f02a6c2&"
import script from "./PptCircleAttr.vue?vue&type=script&lang=js&"
export * from "./PptCircleAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/PptCircleAttr.vue"
export default component.exports